/**
 * Figma C5 / C7 / C8 itinerary step banner (68:10148): white 50 px card on the menu button's row,
 * a 32 px indigo disc with the bike, the step on top ("Étape 1 sur 3 · Vélo Pony"), what to do below.
 */
export function ItineraryBanner(props: { overline: string; title: string }) {
  return (
    <div
      class="flex h-[50px] items-center gap-[9px] rounded-[10px] bg-white pl-[10px] pr-3 shadow-[0_2px_8px_rgba(0,0,0,0.16)]"
      role="status"
    >
      <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-indigo">
        <img src="/icons/bike-white-36.svg" width="20" height="20" alt="" />
      </span>
      <span class="min-w-0">
        <span class="block truncate text-[11px] leading-[1.25] tracking-[0.11px] text-text">
          {props.overline}
        </span>
        <span class="block truncate text-sm font-medium leading-[1.25] tracking-[0.14px] text-strong">
          {props.title}
        </span>
      </span>
    </div>
  );
}
